window.formatMoney = function(cents, format) {
  if (typeof cents == 'string') {
    cents = cents.replace('.', '');
  }
  var value = '';
  var placeholderRegex = /{{\s*(\w+)\s*}}/;
  var formatString = (format || this.money_format);
  function defaultOption(opt, def) {
    return (typeof opt == 'undefined' ? def : opt);
  }
  function formatWithDelimiters(number, precision, thousands, decimal) {
    precision = defaultOption(precision, 2);
    thousands = defaultOption(thousands, ',');
    decimal = defaultOption(decimal, '.');
    if (isNaN(number) || number == null) {
      return 0;
    }
    number = (number / 100.0).toFixed(precision);
    var parts = number.split('.'),
      dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands),
      cents = parts[1] ? (decimal + parts[1]) : '';
    return dollars + cents;
  }
  switch (formatString.match(placeholderRegex)[1]) {
    case 'amount':
      value = formatWithDelimiters(cents, 2);
      break;
    case 'amount_no_decimals':
      value = formatWithDelimiters(cents, 0);
      break;
    case 'amount_with_comma_separator':
      value = formatWithDelimiters(cents, 2, '.', ',');
      break;
    case 'amount_no_decimals_with_comma_separator':
      value = formatWithDelimiters(cents, 0, '.', ',');
      break;
  }
  return formatString.replace(placeholderRegex, value);
};

jQuery(document).ready(function ($) {
  $(".testimonial-slideshow-custom").flickity({
    prevNextButtons: true,
    pageDots: true,
    groupCells: true,
  });

  $(".fpsubclick").on("click", function () {
    $.fancybox.open($(".js-newsletter-popup"), {
      baseClass: "newsletter__lightbox",
      hash: false,
      infobar: false,
      toolbar: false,
      loop: true,
      smallBtn: true,
      mobile: {
        preventCaptionOverlap: false,
        toolbar: true,
        buttons: ["close"],
      },
    });
  });

  if ($(".subprop1").hasClass("rc_block__type--active")) {
    $(".product-section .modal_price").addClass("one-time-select");
  }
  if ($(".subprop2").hasClass("rc_block__type--active")) {
    $(".product-section .modal_price").addClass("subscription-select");
  }

  var bottle3_pro = 0;
  var bottle6_pro = 0;
  var each_price = 0;
  var bottle3_price = 0;
  var bottle6_price = 0;

  each_price = parseFloat($(".sng-sku").attr("data-price"));
  bottle3_pro = 50000 / each_price;
  bottle6_pro = 100000 / each_price;
  bottle3_price = each_price - 500;
  bottle6_price = each_price - 1000;

  if ($("#bottle_3 .botle_right_content:not(botle_right_content--experiment)").length === 0) {
    $("#bottle_3").append(
      '<span class="botle_right_content">' +
        window.formatMoney(bottle3_price, $("body").data("money-format")) +
        '<span class="per_bottle">&nbsp;/ per bottle</span><span class="you_save">Save ' +
        bottle3_pro.toFixed(2) +
        "%</span>"
    );
  }
  if ($("#bottle_6 .botle_right_content:not(botle_right_content--experiment)").length === 0) {
    $("#bottle_6").append(
      '<span class="botle_right_content">' +
        window.formatMoney(bottle6_price, $("body").data("money-format")) +
        '<span class="per_bottle">&nbsp;/ per bottle</span><span class="you_save">Save ' +
        bottle6_pro.toFixed(2) +
        "%</span></span"
    );
  }
  
  $(".sng-sku-button").on("click", function () {
    //console.log(bottle3_pro + '-------' + bottle6_pro + '----------' + each_price);

    $(".sng-sku-button").removeClass("active");
    $(this).addClass("active");
    if ($(this).attr("id") == "bottle_1") {
      $(".product_section .product-quantity-box .quantity").val(1);
      var price = window.formatMoney(
        each_price,
        $("body").data("money-format")
      );
      setTimeout(function () {
        $(".price-ui .price .money").text(price);
      }, 10);
    } else if ($(this).attr("id") == "bottle_3") {
      $(".product_section .product-quantity-box .quantity").val(3);
      var price = window.formatMoney(
        each_price * 3,
        $("body").data("money-format")
      );
      var price_real = window.formatMoney(
        bottle3_price * 3,
        $("body").data("money-format")
      );

      setTimeout(function () {
        $(".price-ui .price .money").html(
          price_real +
            '<span class="was_price">' +
            price +
            "</span><br>" +
            "You Save&nbsp;" +
            bottle3_pro.toFixed(2) +
            "%"
        );
      }, 10);
    } else {
      $(".product_section .product-quantity-box .quantity").val(6);
      var price = window.formatMoney(
        each_price * 6,
        $("body").data("money-format")
      );
      var price_real = window.formatMoney(
        bottle6_price * 6,
        $("body").data("money-format")
      );
      setTimeout(function () {
        $(".price-ui .price .money").html(
          price_real +
            '<span class="was_price">' +
            price +
            "</span><br>" +
            "You Save&nbsp;" +
            bottle6_pro.toFixed(2) +
            "%"
        );
      }, 10);
    }
  });

  $(".rc_block__type__onetime").on("click", function () {
    $(".sng-sku").addClass("active");
    let $selectedBottle = $('.dtc-one-time-purchase-option-picker .sng-sku-button.active');
    if ($selectedBottle.length) updateQtyInput($selectedBottle);
  });

  $(".rc_block__type__autodeliver").on("click", function () {
    $(".sng-sku").removeClass("active");
    $(".product_section .product-quantity-box .quantity").val(1);
    let $selectedBottle = $('.main-delivery .dtc-sub-bottle.active');
    if ($selectedBottle.length) updateQtyInput($selectedBottle);
  });

  $(".sub-plus").on("click", function () {
    var sub_qty = parseInt($(".sub-qty").val()) + 1;
    $(".sub-qty").val(sub_qty);
    $(".product_section .product-quantity-box .quantity").val(sub_qty);
  });
  $(".sub-minus").on("click", function () {
    var sub_qty = parseInt($(".sub-qty").val()) - 1;
    if (sub_qty > 0) {
      $(".sub-qty").val(sub_qty);
      $(".product_section .product-quantity-box .quantity").val(sub_qty);
    }
  });

  $(".sub-qty").on("input", function () {
    var sub_qty = parseInt($(this).val());
    if (sub_qty > 0) {
      $(this).val(sub_qty);
      $(".product_section .product-quantity-box .quantity").val(sub_qty);
    } else {
      $(this).val(1);
    }
  });
});

function updateQtyInput($selectedBottle) {
  let qty = $selectedBottle.attr('data-dtc-quanty');
  if(!qty) return;
  $(".product_section .product-quantity-box .quantity").val(qty);
}

